import { useEffect, useState } from 'react';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { MessagingStoreContext } from '../hooks/use-messaging-store';
import { MessagingStore } from '../store/messaging-store';
import { useApplicationType } from '../../common/hooks/use-application-type';

const Provider: React.FC = ({ children }) => {
    const enabledFeatures = useEnabledFeatures();
    const { isCad } = useApplicationType();

    const [store] = useState(() => new MessagingStore(enabledFeatures, isCad));

    // Update enabledFeatures on the existing store when they change
    useEffect(() => {
        store.enabledFeatures = enabledFeatures;
    }, [enabledFeatures, store]);

    return (
        <MessagingStoreContext.Provider value={store}>{children}</MessagingStoreContext.Provider>
    );
};

export const MessagingStoreProvider: React.FC = ({ children }) => {
    const { messaging } = useEnabledFeatures();
    if (messaging) {
        return <Provider>{children}</Provider>;
    } else {
        return <>{children}</>;
    }
};
